import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export interface IOutstandingDebtDataTableRowFormMeta {
    creditor: FormInputMeta;
    account: FormInputMeta;
    accountHolderName: FormInputMeta;
    initialAmount: FormInputMeta;
    currentBalance: FormInputMeta;
    monthlyPay: FormInputMeta;

    schema: any;
}

const outstandingDebtDataTableRowFormMeta = {} as IOutstandingDebtDataTableRowFormMeta;

outstandingDebtDataTableRowFormMeta.creditor = {
    name: "creditor",
    type: "select",
    label: "Créditeur",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !"),
};

outstandingDebtDataTableRowFormMeta.account = {
    name: "account",
    type: "text",
    label: "Compte",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !"),
};

outstandingDebtDataTableRowFormMeta.accountHolderName = {
    name: "accountHolderName",
    type: "text",
    label: "Nom du Détenteur du Compte",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !"),
};

outstandingDebtDataTableRowFormMeta.initialAmount = {
    name: "initialAmount",
    type: "number",
    label: "Montant initial",
    placeholder: "",
    validation: yup.number(),
};

outstandingDebtDataTableRowFormMeta.currentBalance = {
    name: "currentBalance",
    type: "number",
    label: "Balancee Courant",
    placeholder: "",
    validation: yup.number(),
};

outstandingDebtDataTableRowFormMeta.monthlyPay = {
    name: "monthlyPay",
    type: "number",
    label: "Paiements Mensuels",
    placeholder: "",
    validation: yup.number(),
};


outstandingDebtDataTableRowFormMeta.schema = yup.object().shape(getValidationSchema(outstandingDebtDataTableRowFormMeta));

export default outstandingDebtDataTableRowFormMeta;